import {
  ConfigControllerApi,
  Configuration,
  EmployeeControllerApi,
  EventTrackingControllerApi,
  FormControllerApi,
  MapScoreControllerApi,
  PeriodControllerApi,
  QuestionControllerApi,
  ReviewControllerApi,
  ReviewRequestControllerApi,
  RosterControllerApi,
  SuggestionBoxControllerApi,
  TeamControllerApi,
} from './openapi'

// FIXME token needs to be invalidated and re-fetched on LOGIN
const configuredHost = process.env.REACT_APP_API_HOST
if (!configuredHost && process.env.NODE_ENV === 'production') {
  console.error(
    '[Security] REACT_APP_API_HOST is not set. API calls will fall back to http://localhost:8080 (unencrypted).'
  )
}
export const basePath = configuredHost || 'http://localhost:8080'

export const configuration = new Configuration({
  // TODO configure properly
  basePath,
})

export const employeeAPI = new EmployeeControllerApi(configuration)
export const teamAPI = new TeamControllerApi(configuration)
export const ReviewApi = new ReviewControllerApi(configuration)
export const QuestionApi = new QuestionControllerApi(configuration)
export const FormApi = new FormControllerApi(configuration)
export const EventTrackingApi = new EventTrackingControllerApi(configuration)
export const ReviewRequestApi = new ReviewRequestControllerApi(configuration)
export const PeriodApi = new PeriodControllerApi(configuration)
export const loginAPI = employeeAPI
export const configAPI = new ConfigControllerApi(configuration)
export const suggestionAPI = new SuggestionBoxControllerApi(configuration)
export const mapScoreAPI = new MapScoreControllerApi(configuration)
export const rosterAPI = new RosterControllerApi(configuration)
